import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

import { calcColorStatusGeneral, calcTrazavilidadToString, cellLineaRazonSocial, emptyCell, formatDateWithTimeAMPM } from "../utils";
import { EstadosLiberacionValorInstalacionEnumChoice, TrazabilidadAccionChoiceEnum } from "../constants";
import { IDataSoliLibeValorInstalacion } from "../interfaces";
import { EstadoComponente } from "../components/ui";
import InfoUser from "../components/ui/InfoUser/InfoUser";

interface useTableColumnsLiberacionValorInstalacionProps {
  estado_solicitud: EstadosLiberacionValorInstalacionEnumChoice
}
export const useTableColumnsLiberacionValorInstalacion = ({ 
  
 }: useTableColumnsLiberacionValorInstalacionProps) => {


  const columnBase = useMemo<MRT_ColumnDef<IDataSoliLibeValorInstalacion>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificación',
      size: 200,
      Cell: ({ row }) => row.original.prospecto_data != null
        ? row.original.prospecto_data.identificacion
        : 'N/A'
    },

    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 300,
      disableSortBy: true,
      Cell: ({ row }) => row.original.prospecto_data != null
        ? cellLineaRazonSocial(null, row.original?.prospecto_data.razon_social, row.original.prospecto_data.linea!)
        : 'N/A'
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario solicito',
      Cell: ({ row }) => {
        return <InfoUser user={calcTrazavilidadToString(row.original.trazo_venta_data, TrazabilidadAccionChoiceEnum.SOLICITUD_NO_COBRO_INSTALACION)} />
      },
    },
    {
      accessorKey: 'preventa_data.tipo_plan',
      header: 'Tipo Plan',
      size: 200,
    },
    {
      accessorKey: 'preventa_data.valor_instalacion',
      header: 'Valor Instalacion',
      size: 200,
    },

    {
      accessorKey: 'preventa_data.valor_instalacion_total',
      header: 'Valor Instalacion Total',
      size: 200,
    },

    {
      accessorKey: 'preventa_data.email',
      header: 'Correo',
      size: 200,
    },
    {
      accessorKey: 'codigo',
      header: 'codigo',
      size: 200,
    },
    {
      accessorKey: 'numero_referencia',
      header: 'Numero referencia',
      size: 200,
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha de Solicitud',
      enableColumnFilter: false,
      enableSorting: false,
      size: 200,
      Cell: ({ row }) => (
        row.original.fecha_creacion != null ?
          formatDateWithTimeAMPM(row.original.fecha_creacion) : 'N/A'
      ),
    },
    {
      accessorKey: 'estado',
      header: 'Estado',
      size: 200,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.estado_solicitud != null ?
          <EstadoComponente backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)} texto={row.original.estado_solicitud || ''} /> : null
      ),
    },
    {
      accessorKey: 'motivo',
      header: 'Motivo',
      size: 200,
      Cell: ({ row }) => (emptyCell(row.original.motivo))
    },
    {
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
      Cell({ row }) {
        return emptyCell(row.original.canal_venta_create)
      },
    }
    /* {
      accessorKey: 'user_data.username',
      header: 'Usuario Solicitud',
      size: 200,
      Cell: ({ row }) => (
        row.original.trazo_venta_data.filter(e => e.accion == TrazabilidadAccionChoiceEnum.CREACION)[0].user
      ),
    } */
  ], []);


  return {
    columnBase
  }
}